import React from 'react';
import { settingsFormTypes, searchTableTypes } from '../../constants';
import { getArrayIds } from '../helpers/HelperFunctions';
import { Table } from '../table/Table';
import { TableFilterBlock } from '../table/TableFilterBlock';
import { loadListData } from './ListHelpers';
export async function loadData(page, pageSize, sortBy = '', isDesk = false, filterValues = []) {
    await loadListData.bind(this)(`Table/Get?searchTableTypes=${searchTableTypes.Companies}`, page, pageSize, sortBy, isDesk, filterValues);
}
export async function actionHandlerCallback(actionType, ids) {
    await this.actionHandlerCallbackDefault(actionType, ids);
}
export function renderContent() {
    const { content, sortBy, isDesk, page, pageSize, pageCount, filterValues } = this.state;
    const { type, hideFilter, actionsForAll } = this.props;
    return (
        <div>
            {type !== settingsFormTypes.settingsType && !hideFilter &&
                <TableFilterBlock filterValues={filterValues} onSearch={this.onSearch} exportFileName="companies" onSearchClear={this.onSearchClear} onColumnsUpdateHandler={this.onColumnsUpdateHandler} columnsSettings={{ columns: (content && content.allColumns) ? content.allColumns : [], selected: (content && content.columns) ? getArrayIds(content.columns) : [] }} getItems={this.getItemsForExport} handleUpdate={this.handleReloadData} />
            }
            {content && content.columns &&
                <Table onColumnFilter={this.onColumnFilter} allowDoubleClickAction={true} allCount={content.allCount} handleSortChange={this.handleSortChange} actionHandlerCallback={this.actionHandlerCallback} actionsForAll={actionsForAll ? actionsForAll : content.actionsForAll} columns={content.columns} items={content.rows} showPagination={type !== settingsFormTypes.settingsType} sortBy={sortBy} isDesk={isDesk} page={page} pageSize={pageSize} pageCount={pageCount} handlePageChange={this.handlePageChange} handleChangePageSize={this.handleChangePageSize} />
            }
        </div>
    );
}